import { NylasConnectionStatus } from '../model/nylas-connection-status.dto';
import { NylasConnectionStatusViewModel } from '../model/nylas-connection-status.view-model';

export const isCalendarValid = (nylasConnectionStatus: NylasConnectionStatusViewModel | undefined) => {
  const isConnected = nylasConnectionStatus?.calendar.connected;
  const isStatusValid = nylasConnectionStatus?.calendar.status === NylasConnectionStatus.Valid;

  return isConnected && isStatusValid;
};
